'use client';

import { useCallback } from 'react';

import { useCookies } from 'react-cookie';

import { REGION_PREFERENCE_COOKIE, RegionPreference, encodeRegionPreference, parseRegionPreference, regionCookieOptions } from './utils/region-preference.utils';

interface UseRegionPreferenceResult {
  preference: RegionPreference | undefined;
  setPreference: (preference: RegionPreference) => void;
}

export const useRegionPreference = (): UseRegionPreferenceResult => {
  const [cookies, setCookie] = useCookies([REGION_PREFERENCE_COOKIE]);

  const preference = parseRegionPreference(cookies[REGION_PREFERENCE_COOKIE]);

  const setPreference = useCallback(
    (next: RegionPreference) => {
      setCookie(REGION_PREFERENCE_COOKIE, encodeRegionPreference(next), regionCookieOptions);
    },
    [setCookie]
  );

  return { preference, setPreference };
};
